module.exports = __webpack_public_path__ + "static/img/item5.43cfcda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/item5.png
// module id = CKq3
// module chunks = 1